<template>
  <div>
    <div class="hidden"></div>
    <div class="block pb-4">
      <div 
        v-for="tab in tabs" 
        :key="tab.name" 
        @click="select(tab.name)" 
        class="p-2 text-sm cursor-pointer hover:bg-gray-200 mb-1 rounded-lg"
        :class="tab.current 
          ? 'bg-gradient-to-r from-[#272727] to-[#18161f] text-white rounded-md font-bold' 
          : 'font-light'">
        <span>
          {{ $t(`tabs_vertical.${replaceSpace(tab.name).toLowerCase()}`) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    tabs: Array,
    tabSelect: Function,
  },

  data() {
    return {
      selectedTab: '',
    };
  },
  methods: {
    select(tabName) {
      this.tabs.forEach(tab => {
        tab.current = (tab.name === tabName);
      });
      this.tabSelect(tabName);
    },
    replaceSpace(string) {
      return string.replace(/[,.-]/g, "").replace(/ /g, '_');
    }
  },
  created() {
    // Instead of always selecting the first tab, check if any tab is already marked as current
    const currentTab = this.tabs.find(tab => tab.current);
    
    // Only select the first tab if no tab is currently selected
    if (!currentTab && this.tabs && this.tabs.length > 0) {
      this.select(this.tabs[0].name);
    }
  }
};
</script>
